// extracted by mini-css-extract-plugin
export default {"resetButton":"ODTjn7k","tagBadge":"DlxRk6K","removable":"zn3BzDH","crossIcon":"BLoDoSE","warning":"RAXlynW"};